<template>
  <div>
    <el-dialog title="风险校验" :visible.sync="visible" top="10vh">
      <div class="risk-info">
        <div class="shopInfo">
          <div>企业名称：{{ shopName }}</div>
          <div>校验时间：{{ riskCheckTime }}</div>
        </div>
        <h3>异常风险</h3>
        <div
          v-for="(item, index) in abnormalRiskList"
          :key="item.id"
          @click="handleDetail(item)"
        >
          <div style="margin: 10px 0px">
            {{ item.riskTypeStr
            }}<el-tag type="danger" size="mini" style="margin-left: 10px">{{
              item.riskNum || 0
            }}</el-tag>
          </div>
        </div>
        <h3>正常</h3>
        <div v-for="(item, index) in normalRiskList" :key="item.id">
          <div style="margin: 10px 0px">{{ item.riskTypeStr }}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="riskDetailTitle"
      :visible.sync="detailVisible"
      append-to-body
      :width="detailDialogWidth"
      top="10vh"
    >
      <div
        style="
          display: flex;
          align-items: center;
          flex-direction: row;
          height: 50px;
          flex: 1;
        "
      >
        <div
          v-for="(item, index) in riskTitleList"
          :key="index"
          class="risk-title"
          style="color: #262626; font-size: 14px"
        >
          <span class="risk-title-content">{{ item.colTitleName }}</span>
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          max-height: 70vh;
          overflow-y: auto;
        "
      >
        <div
          v-for="(itemArr, indexArr) in riskDetailList"
          :key="indexArr"
          style="display: flex; flex: 1"
        >
          <div style="display: flex; flex: 1; align-items: center">
            <div
              v-for="(innerItem, innerIndex) in itemArr"
              :key="innerIndex"
              class="risk-title"
            >
              <div v-if="isATagUrl(innerItem.colVal).length > 0">
                <div
                  v-for="(aItem, aIndex) in isATagUrl(innerItem.colVal)"
                  :key="aIndex"
                  v-html="aItem"
                  style="cursor: pointer; line-height: 1.5"
                  :style="{
                    color: aItem.indexOf('<a href') >= 0 ? '#409eff' : '#333',
                  }"
                ></div>
              </div>
              <el-tooltip placement="top" v-else>
                <div slot="content" style="max-width: 500px">
                  {{ innerItem.colVal }}
                </div>
                <span class="risk-title-content">{{
                  innerItem.colVal
                }}</span></el-tooltip
              >
            </div>
          </div>
        </div>
      </div>

      <!-- <el-table :data="riskDetailList" style="width: 100%" :border="true">
        <el-table-column prop="colVal" label="字段名"></el-table-column>
      </el-table> -->
    </el-dialog>
  </div>
</template>
<script>
import { groupBy, head, orderBy } from "lodash";

export default {
  name: "ShopRiskDlg",
  data() {
    return {
      visible: false,
      normalRiskList: [], // 正常风险列表
      abnormalRiskList: [], // 异常风险列表
      detailVisible: false, // 风险详情弹窗
      riskDetailList: [], // 风险详情列表
      riskTitleList: [], // 风险标题列表
      detailDialogWidth: "1000px", // 风险详情弹窗宽度
      riskDetailTitle: "", // 风险详情弹窗标题
      shopName: "", // 店铺名称
      riskCheckTime: "", // 风险时间
    };
  },
  methods: {
    isATagUrl(str) {
      let isA = str.indexOf("<a href") >= 0;
      if (isA) {
        const arr = str.split(",");
        return arr;
      }
      return [];
    },
    publicOpen(risk, certrifyDetail) {
      this.riskList = risk;
      this.groupByRiskItemRows();
      if (certrifyDetail) {
        this.shopName = certrifyDetail.shopName;
        this.riskCheckTime = certrifyDetail.riskCheckTime;
      }
    },
    groupByRiskItemRows() {
      // 如果riskItemRows有值 则分在异常组 ｜ 正常组
      const groupByRiskItemRows = groupBy(this.riskList, (item) => {
        return item.riskItemRows?.length > 0 ? "abnormal" : "normal";
      });
      let normalRiskList = []; // 正常风险列表
      let abnormalRiskList = []; // 异常风险列表
      for (const key in groupByRiskItemRows) {
        if (key === "normal") {
          normalRiskList = groupByRiskItemRows[key];
        } else {
          abnormalRiskList = groupByRiskItemRows[key];
        }
      }
      this.normalRiskList = normalRiskList;
      this.abnormalRiskList = abnormalRiskList;
      this.visible = true;
    },
    handleDetail(risk) {
      this.riskDetailList = risk.riskItemRows;
      this.riskTitleList = risk.riskItemTitles;
      this.riskDetailTitle = risk.riskTypeStr;
      this.detailDialogWidth = this.riskTitleList.length * 150 + "px";
      this.detailVisible = true;
    },
  },
};
</script>
<style scoped lang="scss">
.risk-info {
  height: 66vh;
  overflow-y: auto;
}
.risk-title {
  display: flex;
  flex: 1;
  min-height: 50px;
  font-size: 12px;
  padding: 5px 10px;
  font-weight: 600;
  color: #595959;
}
.risk-title:nth-child(1) {
  flex: 0.5;
}
.risk-title-content {
  display: -webkit-box !important;
  line-height: 24px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
